/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'ai-summary-label': '요약',
  'copy-content-link-label': '링크 복사',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': '텍스트를 입력하여 레이블 검색',
  'dynamic-cards-search-page.app-filter-sidebar.all': '전체',
  'dynamic-cards-search-page.app-filter-sidebar.group': '제품별 필터 검색',
  'dynamic-cards-search-page.avatar': '아바타',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': '캘린더',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': '미팅 참여',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': '미팅 링크',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': '미팅 참여',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': '지난 이벤트',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': '반복 이벤트',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': '반복',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': '예정된 이벤트',
  'dynamic-cards-search-page.compass.owner-name': '소유자: {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': '티어 {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': '콘텐츠 찾기',
  'dynamic-cards-search-page.confluence.filter.content.selected': '선택됨',
  'dynamic-cards-search-page.confluence.filter.content.unselected': '제안됨',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': '선택됨',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': '제안됨',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': '사용자 찾기',
  'dynamic-cards-search-page.confluence.filter.label.selected': '선택됨',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': '레이블 찾기',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': '스페이스 찾기',
  'dynamic-cards-search-page.connect_third_party_product_description': '누락된 결과를 확인하려면 계정을 연결하세요',
  'dynamic-cards-search-page.connect_third_party_product_title': '관리자가 {product}을(를) 추가했습니다!',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '이제 {product}을(를) 사용할 수 있습니다!',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': '시작일은 종료일 이전이어야 합니다',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': '시작일은 미래일 수 없습니다',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': '종료 날짜는 미래일 수 없습니다',
  'dynamic-cards-search-page.date.filter.last.month': '지난 30일',
  'dynamic-cards-search-page.date.filter.last.week': '지난 7일',
  'dynamic-cards-search-page.date.filter.last.year': '지난해',
  'dynamic-cards-search-page.document-search-result.google-docs-label': '문서',
  'dynamic-cards-search-page.document-search-result.google-sheets-label': '시트',
  'dynamic-cards-search-page.document-search-result.google-slides-label': '슬라이드',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': '답변 생성',
  'dynamic-cards-search-page.dropdown_recent_icon_label': '최근 항목',
  'dynamic-cards-search-page.error_primary': '검색에 문제가 발생했습니다',
  'dynamic-cards-search-page.error_secondary':
    '일시적인 문제일 수 있습니다. 가장 좋은 방법은 <btn>다시 시도</btn>하는 것입니다.',
  'dynamic-cards-search-page.externalPeopleLabel': '외부 사용자 #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': '필터 지우기',
  'dynamic-cards-search-page.filter.last.updated.anytime': '모든 시간',
  'dynamic-cards-search-page.filter.last.updated.past30Days': '지난 30일',
  'dynamic-cards-search-page.filter.last.updated.past7Days': '지난 7일',
  'dynamic-cards-search-page.filter.last.updated.pastYear': '지난해',
  'dynamic-cards-search-page.filter.last.updated.today': '오늘',
  'dynamic-cards-search-page.filter.last.updated.yesterday': '어제',
  'dynamic-cards-search-page.filter.type.answer': '답변',
  'dynamic-cards-search-page.filter.type.attachment': '첨부 파일',
  'dynamic-cards-search-page.filter.type.blogpost': '블로그 게시물',
  'dynamic-cards-search-page.filter.type.branch': '브랜치',
  'dynamic-cards-search-page.filter.type.calendar': '캘린더',
  'dynamic-cards-search-page.filter.type.comment': '댓글',
  'dynamic-cards-search-page.filter.type.commit': '커밋',
  'dynamic-cards-search-page.filter.type.component': '컴포넌트',
  'dynamic-cards-search-page.filter.type.conversation': '대화',
  'dynamic-cards-search-page.filter.type.database': '데이터베이스',
  'dynamic-cards-search-page.filter.type.design': '디자인',
  'dynamic-cards-search-page.filter.type.documents': '문서',
  'dynamic-cards-search-page.filter.type.message': '메세지',
  'dynamic-cards-search-page.filter.type.page': '페이지',
  'dynamic-cards-search-page.filter.type.placeholder': '유형 찾기',
  'dynamic-cards-search-page.filter.type.presentation': '프레젠테이션',
  'dynamic-cards-search-page.filter.type.pull-request': '풀리퀘스트',
  'dynamic-cards-search-page.filter.type.question': '질문',
  'dynamic-cards-search-page.filter.type.repository': '리포지토리',
  'dynamic-cards-search-page.filter.type.space': '스페이스',
  'dynamic-cards-search-page.filter.type.space-calendar': '스페이스 캘린더',
  'dynamic-cards-search-page.filter.type.spreadsheet': '스프레드시트',
  'dynamic-cards-search-page.filter.type.video': '동영상',
  'dynamic-cards-search-page.filter.type.web-page': '웹 페이지',
  'dynamic-cards-search-page.filter.type.whiteboard': '화이트보드',
  'dynamic-cards-search-page.filters.dropdown.clear-all': '모두 지우기',
  'dynamic-cards-search-page.filters.dropdown.title': '필터',
  'dynamic-cards-search-page.filters.names.content': '상위 콘텐츠',
  'dynamic-cards-search-page.filters.names.contributor': '기여자',
  'dynamic-cards-search-page.filters.names.labels': '레이블',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': '제목 일치',
  'dynamic-cards-search-page.github-branch-result.label': '브랜치',
  'dynamic-cards-search-page.github-commit-result.label': '커밋',
  'dynamic-cards-search-page.github-pull-request-result.label': '풀리퀘스트',
  'dynamic-cards-search-page.jira.filter.project.placeholder': '프로젝트 찾기',
  'dynamic-cards-search-page.landing_primary': '동적 카드용 필터 시작하기',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': '검색 조건과 일치하는 사항을 찾지 못했습니다',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    '몇 가지 필터를 적용한 것 같습니다. 지워 볼 수 있습니다.',
  'dynamic-cards-search-page.nouns.goal': '목표',
  'dynamic-cards-search-page.nouns.goals': '목표',
  'dynamic-cards-search-page.nouns.tag': '태그',
  'dynamic-cards-search-page.nouns.tags': '태그',
  'dynamic-cards-search-page.number_of_results': '{numberOfResults,number}/{totalCount,number}개의 결과 표시',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': '{product} 권한 부여에 실패했습니다.',
  'dynamic-cards-search-page.oauth-banner.authorization-success': '{product} 권한 부여에 성공했습니다.',
  'dynamic-cards-search-page.oauth-message-connect': '연결',
  'dynamic-cards-search-page.products.custom-website': '웹 페이지',
  'dynamic-cards-search-page.results-sort.createdDate.selected': '만든 날짜 기준 정렬(최신순)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': '만든 날짜(최신순)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': '업데이트 날짜(최신순)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': '업데이트 날짜 기준 정렬(최신순)',
  'dynamic-cards-search-page.results-sort.sort-options.label': '목록 정렬 변경',
  'dynamic-cards-search-page.rovo-onboarding-next': '다음',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    '더욱 관련이 높은 검색 결과를 얻으려면 제품별로 필터링하세요.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': '회사 작업 영역 전체에서 검색하기',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    '필터링하려는 제품에 따라 특정 결과를 얻을 수 있도록 이 옵션이 변경됩니다.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': '원하는 항목을 정확히 찾아보기',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': '첨부 파일',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': '{formattedDate}에 첨부',
  'dynamic-cards-search-page.search-result.attachments.audio-label': '오디오',
  'dynamic-cards-search-page.search-result.attachments.expand.label': '확장',
  'dynamic-cards-search-page.search-result.attachments.image-label': '이미지',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': '{formattedDate}에 업데이트',
  'dynamic-cards-search-page.search-result.private-channel-label': '비공개 채널',
  'dynamic-cards-search-page.search-result.remove-recent-search': '최근 검색 제거 아이콘',
  'dynamic-cards-search-page.search-result.repository-label': '리포지토리',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {외부 사용자와 그룹 메시지} =2 {{name1} 님 및 {name2} 님} =3 {{name1} 님, {name2} 님 및 {name3} 님} =4 {{name1} 님, {name2} 님, {name3} 님 및 그 외 {overflowContributorCount}명} other {{name1} 님, {name2} 님, {name3} 님 및 그 외 {overflowContributorCount}명}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': '알-수-없는-채널',
  'dynamic-cards-search-page.search_result_type_answer': '답변',
  'dynamic-cards-search-page.search_result_type_card': '카드',
  'dynamic-cards-search-page.search_result_type_commit': '제출',
  'dynamic-cards-search-page.search_result_type_component': '컴포넌트',
  'dynamic-cards-search-page.search_result_type_document': '문서',
  'dynamic-cards-search-page.search_result_type_embed': '스마트 링크',
  'dynamic-cards-search-page.search_result_type_folder': '폴더',
  'dynamic-cards-search-page.search_result_type_presentation': '프레젠테이션',
  'dynamic-cards-search-page.search_result_type_pull_request': '풀리퀘스트',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'Sharepoint 문서',
  'dynamic-cards-search-page.search_result_type_space_calendar': '스페이스 캘린더',
  'dynamic-cards-search-page.search_result_type_spreadsheet': '스프레드시트',
  'dynamic-cards-search-page.search_result_type_unrecognised': '미인식',
  'dynamic-cards-search-page.search_result_type_work_item': '업무 항목',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    '관리자가 <strong>{product}</strong>을(를) 추가했습니다!{br} 자신만 액세스할 수 있는 문서를 포함하여 누락된 결과를 보려면 계정을 연결하세요.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>이제 {product}을(를) 사용할 수 있습니다!</strong>{br} 자신만 액세스할 수 있는 문서를 포함하여 누락된 결과를 보려면 계정을 연결하세요.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': '권한 부여',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': '{product} 권한 부여에 실패했습니다.',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': '{product} 권한 부여에 성공했습니다.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': '모든 앱으로 필터링',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': '더 많은 앱으로 필터링',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': '보관됨',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': '위험',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': '취소됨',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': '완료',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': '계획에서 벗어남',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': '계획대로 진행 중',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': '일시 중지됨',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': '대기 중',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, other {이 동영상의 {chapterCount,number}개 챕터}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': '동영상 아이콘',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': '동영상 썸네일',
  'dynamic-cards-search-page.work-item-assignee.assigned': '님이 할당됨',
  'dynamic-cards-search-page.work-item-creator.created': '님이 만듦',
  'dynamic-cards-search-page.work-item-status.for': ':',
  'dynamic-cards-search-page.work-item-ticket.label': '티켓',
  'dynamic-cards-search-page.work-item.label': '업무 항목',
  'initialsAvatar.label': '이니셜 아바타',
  'personAvatar.label': '사람 아바타',
  'search-page.results.private-result-label': '비공개',
  'search-page.results.private-result-tooltip': '자신만 볼 수 있음',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, other {{memberCount,number}명 구성원}}',
  'search-page.results.product-results.third-party.channel-type-label': '채널',
  'search-page.results.product-results.third-party.conversation-search-result.label': '채널',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, other {구성원 {count,number}명}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    '마지막 활성: {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': '알-수-없는-채널',
  'search-page.results.product-results.third-party.external-people-label': '외부 사용자',
  'search-page.results.product-results.third-party.external-person-label': '외부 사용자',
  'search-page.results.product-results.third-party.last-active': '마지막 활성: {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': '메시지',
  'search-page.results.product-results.third-party.no-contributors-label': '#{channelName}의 외부 사용자',
  'search-page.results.product-results.third-party.private-conversation-text': '비공개 대화에 {users}',
  'search-page.results.product-results.third-party.thread-type-label': '스레드',
  'search-page.results.product-results.third-party.title-and-channel-name': '#{channelName}의 {title}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, other {{title} 님 및 그 외 {remainingContributorsCount}명}}',
  'search-page.results.restricted-result-label': '제한됨',
  'search-page.results.restricted-result-tooltip': '특정 사용자만 볼 수 있음',
  'search-page.show-more-breadcrumbs-button-label': '이동 경로 더 표시',
  'search-page.verified-icon-label': '확인됨',
  'search-page.verified-icon-tooltip-message': '소유자 또는 관리자가 이 페이지를 확인했습니다.',
  'search-result.result.count': '{count, plural, other {결과 {count}개 표시 중}}',
  'search-result.user-mention.external-person': '외부 사용자',
};
